import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import Button from "../../../../FormElement/Button";
import InputFiled from "../../../../FormElement/InputFiled";


class CommodityForm extends Component {
  state = {};
  render() {
    const {
      commodityInfo,
      createCommodity,
      buttonLabel,
      formLabel,
      isValid,
      handleChange,
      handleError
    } = this.props;
    return (
      <div className="">
        <div className="textRequired">* Required Cells</div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <InputFiled
                label="Commodity Name"
                value={commodityInfo.name}
                required
                validations={["required"]}
                handleError={handleError}
                handleChange={handleChange}
                type="text"
                name="name"
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={commodityInfo.lbsPerBushel}
                label="lbs Per Bushel"
                required
                validations={["required"]}
                handleError={handleError}
                type="number"
                name="lbsPerBushel"
                handleChange={handleChange}
              />
            </Grid>
          </Grid>
          <div className="signInSection">
            <Button
              name={buttonLabel}
              disabled={isValid}
              onclick={createCommodity}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CommodityForm;



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/Commodities/CommodityForm.js